module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_13-bfe86bcf05e872d37d4ff21d3a889a1d.jpg";